var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#303030",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_7360)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9969 4.00005C40.2744 3.98815 32.686 6.01879 26.0015 9.88601C25.0454 10.4391 23.822 10.1125 23.2688 9.15639C22.7157 8.2003 23.0424 6.97683 23.9984 6.42369C31.2931 2.20347 39.574 -0.012655 48.0015 5.43594e-05C74.5111 0.00088346 96 21.4902 96 48C96 74.5104 74.5103 96 48 96C21.4896 96 0 74.5104 0 48C0 39.2627 2.3375 31.0568 6.42392 23.998C6.97732 23.0421 8.20088 22.7158 9.15682 23.2692C10.1128 23.8226 10.4391 25.0461 9.88568 26.0021C6.1429 32.4673 4 39.9841 4 48C4 61.1221 9.74365 72.9022 18.8541 80.9636C19.4839 75.6252 20.973 70.6939 24.6098 66.9229C29.1043 62.2624 36.4501 59.8 48 59.8C59.5498 59.8 66.8956 62.2624 71.3902 66.9229C75.027 70.6939 76.5161 75.6252 77.1458 80.9636C86.2563 72.9022 92 61.1221 92 48C92 23.6988 72.3012 4.00005 48 4.00005L47.9969 4.00005ZM73.4038 83.9304C72.9777 77.8391 71.752 73.0602 68.511 69.6996C65.1223 66.1859 59.1051 63.8 48 63.8C36.8948 63.8 30.8776 66.1859 27.489 69.6996C24.2479 73.0602 23.0222 77.8391 22.5961 83.9303C29.7719 89.013 38.537 92 48 92C57.4629 92 66.228 89.013 73.4038 83.9304ZM48 22.4C41.483 22.4 36.2 27.683 36.2 34.2C36.2 40.7169 41.483 46 48 46C54.5169 46 59.8 40.7169 59.8 34.2C59.8 27.683 54.5169 22.4 48 22.4ZM32.2 34.2C32.2 25.4739 39.2739 18.4 48 18.4C56.7261 18.4 63.8 25.4739 63.8 34.2C63.8 42.9261 56.7261 50 48 50C39.2739 50 32.2 42.9261 32.2 34.2Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_7360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user-avatar.e31bb7c9.svg";
export { ForwardRef as ReactComponent };